import { useEffect, useState } from 'react'

// Paginación puramente de UI: quien la usa ya filtró y ordenó el listado
// completo; este hook solo decide qué "página" de ese arreglo mostrar.
//
// `filtrosKey` debe ser un string que cambie cuando cambia CUALQUIER
// filtro (no la página ni el tamaño de página) — al cambiar, se vuelve a
// la página 1 automáticamente. Cambiar de página o de tamaño de página
// nunca toca los filtros (son estados independientes).
export function usePaginacion({
  totalRegistros,
  filtrosKey,
  tamanioPaginaInicial = 20,
}) {
  const [pagina, setPagina] = useState(1)
  const [tamanioPagina, setTamanioPaginaState] = useState(
    tamanioPaginaInicial
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setPagina(1)
  }, [filtrosKey])

  const totalPaginas = Math.max(
    1,
    Math.ceil(totalRegistros / tamanioPagina)
  )

  useEffect(() => {
    if (pagina > totalPaginas) {
      setPagina(totalPaginas)
    }
  }, [pagina, totalPaginas])

  const setTamanioPagina = (valor) => {
    setTamanioPaginaState(valor)
    setPagina(1)
  }

  const paginaSegura = Math.min(pagina, totalPaginas)
  const indiceInicio =
    totalRegistros === 0 ? 0 : (paginaSegura - 1) * tamanioPagina + 1
  const indiceFin = Math.min(
    paginaSegura * tamanioPagina,
    totalRegistros
  )

  return {
    pagina: paginaSegura,
    setPagina,
    tamanioPagina,
    setTamanioPagina,
    totalPaginas,
    indiceInicio,
    indiceFin,
  }
}
